module.exports = __webpack_public_path__ + "img/invigorate-small.f86ed5a6.png";